import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ConfigService } from 'ngx-envconfig';

@Component({
  selector: 'fury-show-delivery-account',
  templateUrl: './show-delivery-account.component.html',
  styleUrls: ['./show-delivery-account.component.scss']
})
export class ShowDeliveryAccountComponent implements OnInit {


  item: any;


   constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private configService: ConfigService,
    private dialogRef: MatDialogRef<ShowDeliveryAccountComponent>) {
    this.item = this.data.payload;

  }



  ngOnInit() {
  }

}
